export default {
      id: "reefer-ok-usage",
      viewBox: "0 0 101 96",
      url: __webpack_public_path__ + "img/icons.svg#reefer-ok",
      toString: function () {
        return this.url;
      }
    }